/**
 * Чем указывают: пальцем или мышью.
 *
 * Спрашиваем у браузера про ГРУБЫЙ указатель, а не про ширину экрана: на
 * планшете с клавиатурой окно широкое, а тычут всё равно пальцем — и наоборот,
 * узкое окно на компьютере остаётся мышью.
 *
 * От этого зависят разные мелочи: плитку мышью открывают двойным щелчком, а
 * пальцем одним касанием; ярлык мессенджера на компьютере ведёт в настольное
 * приложение, а на телефоне — обычной ссылкой, которую телефон сам отдаёт
 * нужному приложению.
 */
export function сенсорный(): boolean {
  /* В тестовой среде `matchMedia` может не быть вовсе — считаем это мышью. */
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(pointer: coarse)').matches;
}
